import LoaderLogo from './loader-logo'
export default LoaderLogo
